/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 * DChatButton component
 *
 * @author Nikolay Sviridov
 * @version 1.38.0
 * @since 1.38.0
 */

import { BadgeCounter, IconButton } from '@nexign/scc-ui-kit';
import { useDispatch } from 'react-redux';

import { icons } from '@/main/assets';
import { ImgStyled } from '@components/common/Block/Img';
import { DChatModal } from '@modules/dchat/DChatModal';
import { modalOpen } from '@modules/modal/modalActions';
import { IModalRenderProps } from '@modules/modal/types/modalTypes';

interface IDChatButtonProps {
    isDisabled: boolean;
}

export const DChatButton = (props: IDChatButtonProps) => {
    const { isDisabled } = props;
    const dispatch = useDispatch();
    const openModal = () => {
        dispatch(modalOpen({
                modalParams: {
                    isCustomCrossButton: true,
                },
                render: (p: IModalRenderProps) => <DChatModal
                    onModalClose={() => {
                        p.onCloseModal();
                    }} />,
            }))
    };
    return (
        <IconButton disabled={isDisabled} onClick={openModal}>
            <BadgeCounter>
                <ImgStyled className="medium" src={icons.messageIconMedium} />
            </BadgeCounter>
        </IconButton>
    );
}
